<mat-form-field class="input" [appearance]="appearance" (click)="touched = true">
  <mat-label class="mb-xs" *ngIf="label" [ngClass]="{ asterix: required }">{{ label }}</mat-label>

  <input
    *ngIf="isCurrencyInput"
    matInput
    [type]="type"
    [disabled]="isDisabled" 
    [(ngModel)]="value"
    (ngModelChange)="ngModelChange.emit($event); onChange(value)"
    (change)="onChange(value)"
    (click)="handleClick($event); onTouched()"
    [errorStateMatcher]="matcher"
    [placeholder]="placeholder"
    [mask]="mask"
    [thousandSeparator]="thousandSeparator"
    [decimalMarker]="decimalMarker"
    [prefix]="prefix"
    [showMaskTyped]="showMaskTyped"
    [dropSpecialCharacters]="!showMaskTyped"
    (paste)="onPaste($event)"
    (drop)="onDrop($event)"
    (keydown.enter)="handleKeyEnter($event)"
    [appDataTestid]="ngControl.name"
    maxlength="256"
    (blur)="onBlur()" />

  <input
    (blur)="onBlur()"
    *ngIf="!isCurrencyInput"
    matInput
    [type]="type"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (ngModelChange)="ngModelChange.emit($event); onChange(value)"
    (change)="onChange(value)"
    (click)="handleClick($event); onTouched()"
    [errorStateMatcher]="matcher"
    [placeholder]="placeholder"
    [mask]="mask"
    [showMaskTyped]="showMaskTyped"
    [dropSpecialCharacters]="!showMaskTyped"
    (paste)="onPaste($event)"
    (drop)="onDrop($event)"
    (keydown.enter)="handleKeyEnter($event)"
    (keypress)="validateNumberInput($event)"
    [appDataTestid]="ngControl.name"
    maxlength="256" />
  <mat-icon *ngIf="sufix" matSuffix (click)="sufixClick.emit($event)">{{ sufix }}</mat-icon>
  <mat-error>
    <app-errors-label [label]="label" *ngIf="touched && ngControl.errors"
      [errors]="ngControl.errors"></app-errors-label>
  </mat-error>
</mat-form-field>